import { render, staticRenderFns } from "./HomeNews.vue?vue&type=template&id=2aa25ddd&scoped=true"
import script from "./HomeNews.vue?vue&type=script&lang=ts"
export * from "./HomeNews.vue?vue&type=script&lang=ts"
import style0 from "./HomeNews.vue?vue&type=style&index=0&id=2aa25ddd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa25ddd",
  null
  
)

export default component.exports